import { useEffect, useState } from 'react';
import { numToOrdinalSuffix } from '@/utils/strings';
import Accordion from '@/components/Accordion';
import FormGroupPanel from '@/components/Accordion/panels/FormGroup';
import SelectionsList from '../SelectionsList';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const SelectionsModalCollectionsList = _ref => {
  let {
    collections,
    invalids,
    activeSelection,
    activeCollection,
    highlightColors,
    isAdding,
    maxSelections,
    textOverrides = {},
    sheetNames = [],
    onChangeAddMode = () => undefined,
    onActivateCollection = () => undefined,
    onActivateSelection = () => undefined,
    onRemoveSelection = () => undefined,
    onRemoveCollection = () => undefined
  } = _ref;
  const {
    0: hiddenCollections,
    1: setHiddenCollections
  } = useState([]);

  const updateSelectionState = (selectionIndex, collectionIndex) => {
    onActivateSelection(selectionIndex, true);
    onActivateCollection(collectionIndex);
  };

  const toggleCollection = (collectionIndex, selectionsCount) => {
    const isCollectionHidden = hiddenCollections.indexOf(collectionIndex) !== -1;

    if (isCollectionHidden) {
      showCollection(collectionIndex); // Auto activate/deactivate selections

      updateSelectionState(selectionsCount ? 0 : -1, collectionIndex);
      onChangeAddMode(!selectionsCount);
    } else {
      // Hide collection
      setHiddenCollections([...hiddenCollections, collectionIndex]);
    } // Deactivate active selections


    const isActive = activeCollection === collectionIndex;

    if (isActive && !isCollectionHidden) {
      updateSelectionState(-1, -1);
      onChangeAddMode(false);
    }
  };

  const removeCollection = collectionIndex => {
    onRemoveCollection(collectionIndex); // remove collection index from hidden collections

    showCollection(collectionIndex);
  };

  const showCollection = collectionIndex => {
    setHiddenCollections(hiddenCollections.filter(index => index !== collectionIndex));
  }; // Auto-reveal the active collection that's hidden


  useEffect(() => {
    if (hiddenCollections.indexOf(activeCollection) !== -1) {
      setHiddenCollections(hiddenCollections.filter(index => index !== activeCollection));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [activeCollection]);
  const isSingleCollection = collections.length === 1;
  return /*#__PURE__*/_jsx(Accordion, {
    containerClassName: styles.collectionsList,
    children: collections.map((collection, collectionIndex) => {
      const isActiveCollection = activeCollection === collectionIndex;
      const selectionsCount = collection.length;
      const groupTitle = (textOverrides === null || textOverrides === void 0 ? void 0 : textOverrides.groupTitle) || 'Group';
      const groupTitleWithCount = `${numToOrdinalSuffix(collectionIndex + 1)} ${groupTitle}${selectionsCount > 0 ? ` (${selectionsCount})` : ''}`;
      const panelTitle = isSingleCollection ? groupTitle : groupTitleWithCount;
      return /*#__PURE__*/_jsx(FormGroupPanel, {
        title: panelTitle,
        isOpen: hiddenCollections.indexOf(collectionIndex) === -1,
        className: styles.formGroupPanel,
        isToggleable: collections.length > 1,
        onClick: () => {
          toggleCollection(collectionIndex, selectionsCount);
        },
        children: /*#__PURE__*/_jsx(SelectionsList, {
          selections: collection,
          invalidSelections: invalids[collectionIndex],
          activeSelection: isActiveCollection ? activeSelection : -1,
          highlightColor: highlightColors[collectionIndex],
          collectionIndex: collectionIndex,
          isAdding: isAdding && isActiveCollection,
          sheetNames: sheetNames,
          maxSelections: maxSelections,
          className: styles.selectionsList,
          onActivateSelection: selectionIndex => {
            updateSelectionState(selectionIndex, collectionIndex);
          },
          onRemoveSelection: selectionIndex => {
            // Delete collection if only one selection is left in it
            if (collection.length === 1 && collectionIndex !== 0) {
              removeCollection(collectionIndex);
            } else {
              onRemoveSelection(collectionIndex, selectionIndex);
            }
          },
          onChangeAddMode: adding => onChangeAddMode(adding, collectionIndex)
        })
      }, `collection-${collectionIndex}`);
    })
  });
};

export default SelectionsModalCollectionsList;